export const REWARD_VALUE_TYPE_NOMINAL = "NOMINAL";
export const REWARD_VALUE_TYPE_PERCENTAGE = "PERCENTAGE";

export const rewardValueTypeSelectOptions = (t: (key: string) => string) => [
  { value: REWARD_VALUE_TYPE_NOMINAL, label: t("RewardValueType-Nominal") },
  { value: REWARD_VALUE_TYPE_PERCENTAGE, label: t("RewardValueType-Percentage") },
];
